import React from 'react'
import ButtonBase, { ButtonProps, ButtonRole } from '~/components/atoms/button/ButtonBase'
import { useColor } from '~/hooks/server/color'

const SupportButton = ({children, ...props}: ButtonProps) => {
  const color = useColor()
  return (
    <ButtonBase role={ButtonRole.SUPPORT} color={color} {...props}>
      {children}
    </ButtonBase>
  )
}

export default SupportButton